(function ($) {
    function setCookie(key, value) {
        var expires = new Date();
        expires.setTime(expires.getTime() + 36000000); //1hour
        document.cookie = key + '=' + encodeURIComponent(value) + ';expires=' + expires.toUTCString() + ';path=/';
    };

    function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return decodeURIComponent(keyValue ? keyValue[2] : null);
    };

    var $registration = {
        $files: [],
        $error: {
            '-701': 'MEMORY_ERROR',
            '-702': 'IMAGE_DIMENSIONS_ERROR',
            '-700': 'IMAGE_FORMAT_ERROR',
            '-602': 'FILE_DUPLICATE_ERRO',
            '-601': '添付できるファイル形式は.pdf,.gif,.jpg,.jpeg,.png,.doc,.docs,.xls,.xlsx,.ppt,.pptx,.zipです。',
            '-600': '１ファイル 8 MBまでです。',
            '-500': 'INIT_ERROR',
            '-400': 'SECURITY_ERROR',
            '-300': 'IO_ERROR',
            '-200': 'HTTP_ERROR',
            '-100': 'GENERIC_ERROR'
        },
        $file_uploaded: 0,
        $max_number_of_files: 3,
        $form_wrapper: '',
        $loading: 'form_loading',
        validation: function ($, $form) {
            if (app_start_local_data.current_page !== 'registration-facebook-api-redirect' && app_start_local_data.current_page !== 'skill-registration') {
                $form.validate({
                    errorClass: 'required',
                    // debug: true,
                    ignore: [],
                    errorPlacement: function (error, element) {
                    },
                    rules: {
                        firstname: {
                            registerNoJustWhiteSpace: true
                        },
                        lastname: {
                            registerNoJustWhiteSpace: true
                        },
                        firstname_kana: {
                            kana: true
                        },
                        lastname_kana: {
                            kana: true
                        },
                        email: {
                            checkEmail: true
                        }
                    }
                });
            } else if( app_start_local_data.current_page === "skill-registration"){
                $form.validate({
                    errorClass: 'required',
                    errorPlacement: function (error, element) {
                    },
                    rules: {
                        phone: {
                            registerNoJustWhiteSpace: true
                        },
                    }
                });
            } else {
                $form.validate({
                    errorClass: 'required',
                    errorPlacement: function (error, element) {
                    },
                    rules: {}
                });
            }
        },
        registerNoJustWhiteSpace: function ($) {
            $.validator.addMethod("registerNoJustWhiteSpace", function (value, element) {
                return value.trim().length > 0 && value;
            }, "");
        },
        kana: function ($) {
            $.validator.addMethod("kana", function (value, element) {
                return value.trim().length > 0 && value.match(/[\u30A0-\u30FF]/);
            }, "");
        },
        checkEmail: function ($) {
            var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
            $.validator.addMethod("checkEmail", function (value, element) {
                return pattern.test(value);
            }, "");
        },
        plupload: function () {
            return new plupload.Uploader({
                browse_button: 'fu-browse',
                drop_element: 'registration-drop',
                url: app_start_local_data.upload_file,
                max_file_size: '8mb',
                max_file_count: 3,
                filters: [
                    {title: "Image files", extensions: "jpg,gif,png,pdf,txt,xls,xlsx,doc,docx,jpge,ppt,pptx,csv"},
                    {title: "Zip files", extensions: "zip"}
                ]
            });
        },
        fileAddedMarkUp: function ($, file, error) {
            var $fileId = file.id;
            var $fileName = file.name;
            var $uploadContainer = $('.uploaded-files');
            var errorClass = error ? 'fu-error' : '';
            var $markUp = '<span class="single-uploaded ' + errorClass + '" id="' + $fileId + '">' +
                '           <span class="name">' + $fileName + '</span>' +
                '               <a href="" class="delete fu-p-delete" data-file-id="' + $fileId + '">' +
                '                <img src="' + app_start_local_data.template_directory + '/assets/images/close.png" alt="">' +
                '               </a>' +
                '          </span>';
            $('.upload-file-button-js').before($markUp);
        },
        onlifeAdded: function ($, $this, $plupload) {
            $plupload.bind('FilesAdded', function (up, files) {
                $plupload.start();
            });
        },
        fileUploadEvent: function ($, $plupload, $this) {
            $plupload.bind('FileUploaded', function (uploader, file, response) {
                $fileDiv = $('#' + file.id);
                $fileName = response.response;
                $fileDiv.find('.fu-p-delete').attr('data-file-name', $fileName);
                $this.$files.push($fileName);
                $('input[name="files"]').val(JSON.stringify($this.$files));
                $fileDiv.animate({opacity: 1});
            });

            $plupload.bind('UploadComplete', function (uploader, file, response) {
                $this.$form_wrapper.removeClass($this.$loading);
            });

            $plupload.bind('BeforeUpload', function (upload, file) {
                if (upload.total.uploaded < $this.$max_number_of_files) {
                    $this.fileAddedMarkUp($, file);
                    $this.$form_wrapper.addClass($this.$loading);
                    $this.$file_uploaded++;
                } else {
                    var numberOfRemainingElement = $plupload.files.length - $this.$max_number_of_files;
                    if (numberOfRemainingElement > 0) {
                        $plupload.files.splice($this.$max_number_of_files, numberOfRemainingElement);
                    }
                    $plupload.stop();
                    $this.$form_wrapper.removeClass($this.$loading);
                    $this.errorMessage($, $this.$max_number_of_files+'つのファイルしか追加できません');
                }
            });
        },
        fileDelete: function ($, $plupload, $this) {
            $(document).on('click', '.fu-p-delete', function (e) {
                e.preventDefault();
                if (!($(this).parent().hasClass('fu-error'))) {
                    $this.$file_uploaded--;
                }
                var $inqury_submit = $('.formAction');
                var $singleFiles = $('.fu-preview');
                $inqury_submit.find('input').attr('disabled', "disabled");
                $singleFiles.addClass('appstar_disable');
                $fileId = $(this).attr('data-file-id');
                $fileName = $(this).attr('data-file-name');
                $plupload.files.forEach(function (index) {
                    if (index.id == $fileId) {
                        $plupload.removeFile(index);
                    }
                });
                $this.$form_wrapper.addClass($this.$loading);
                $.post(app_start_local_data.ajaxurl, {
                    'action': 'delete-uploaded-file',
                    'data': {
                        'name': $fileName
                    }
                }, function (response) {
                    $this.$form_wrapper.removeClass($this.$loading);
                    if ($this.$files.indexOf($fileName) != -1) {
                        $this.$files.splice($this.$files.indexOf($fileName), 1);
                    }
                    $inqury_submit.find('input').removeAttr('disabled');
                    $this.$form_wrapper.removeClass($this.$loading);
                });
                $parent = $('#' + $fileId);
                $parent.remove();
            });
        },
        onPlupError: function ($, $plupload, $this) {
            $plupload.bind('Error', function (up, err) {
                var error = $this.$error[err.code];
                $this.fileAddedMarkUp($, err.file, error);
                $this.errorMessage($, error);
            }, [], 0);
        },
        formSubmit: function ($, $this, $plupload, $form) {
            $form.on('submit', function (e) {
                var reCaptchaValidation = false;
                var registrationForm = this;
                
                if ($(this).valid() ) {
                    if($(registrationForm).find('.g-recaptcha').length){
                        const data = {
                            'action': 'check_recaptcha',
                            'captcha': $(registrationForm).find('#g-recaptcha-response').val(),
                            'nonce': $('#g-recaptcha').data('nonce')
                        };
                        $.ajax({
                            type: 'POST',
                            url: app_start_local_data.ajaxurl,
                            data: data,
                            success: function(response){
                                if (response == 'true') {
                                    $(registrationForm).find('.g-recaptcha').closest(".registration-form-row").find(".invalid-feedback").hide();
                                    $this.$form_wrapper.addClass($this.$loading);
                                } 
                                else {
                                    $(registrationForm).find('.g-recaptcha').closest(".registration-form-row").find(".invalid-feedback").show().css('color', '#ff4b4b');
                                    e.preventDefault();
                                }
                            },
                            async:false
                        });
                    }else{
                        $this.$form_wrapper.addClass($this.$loading);
                    }  
                } else {
                    e.preventDefault();
                }
            });
        },
        errorMessage: function ($, $message) {
            var errorWrapper = $('.file-upload-error'),
                newError = $('<p>', {class: 'upload-error'});
            newError.text($message);
            newError.appendTo(errorWrapper);
            setTimeout(function () {
                newError.fadeOut(1000, function () {
                    $(this).remove();
                });
            }, 10000);
        },
        int: function ($) {
            this.$form_wrapper = $('.form-wrapper-js');
            if (app_start_local_data.current_page === 'skill-registration') {
                var $form = $('.appstar-skill-form-js');
            } else {
                var $form = $('#registrationForm');
            }
            var $pluploadHandler = this.plupload();
            $pluploadHandler.init();
            this.registerNoJustWhiteSpace($);
            this.kana($);
            this.checkEmail($);
            this.validation($, $form, this, $pluploadHandler);
            this.onlifeAdded($, this, $pluploadHandler);
            this.fileUploadEvent($, $pluploadHandler, this);
            this.fileDelete($, $pluploadHandler, this);
            this.onPlupError($, $pluploadHandler, this);
            this.formSubmit($, this, $pluploadHandler, $form);
        }
    };
    $registration.int($);
}(jQuery));